"use client";

import React, { useRef } from "react";
import { motion, useScroll, useTransform, useSpring } from "framer-motion";
import "./InquireNowNew.css";
export default function InquireNowNew({
  projectId,
  handleSubmit,
  inquiryObj,
  handleChange,
  errors,
  formSubmitted,
  submitLoad,
  countryFlag,
  setCountryFlag,
  countryList,
  search,
  setSearch,
  handleCountrySelect,
}) {
  const formRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: formRef,
    offset: ["start 100%", "start 20%"],
  });

  const smoothProgress = useSpring(scrollYProgress, {
    stiffness: 80,
    damping: 25,
    mass: 0.5,
  });

  const clipPath = useTransform(
    smoothProgress,
    [0, 1],
    [
      "inset(0px 0% 0px 0%)", // fully cover
      "inset(0px 0% 0px 50%)", // stop at 50%
    ],
  );

  const inquiryProjectImages = {
    880: {
      name: "Nb Palm",
      image: "/images/inquiry-imgs/palm-Inquire_now-1.jpg",
      bgImage: "/images/inquiry-imgs/palm-Inquire_now-2.jpg",
    },

    887: {
      name: "Nb Parva",
      image: "/images/inquiry-imgs/Parva-Inquire_now-1.jpg",
      bgImage: "/images/inquiry-imgs/Parva-Inquire_now-2.jpg",
    },

    881: {
      name: "Nb Sarvam",
      image: "/images/inquiry-imgs/Sarvam-Inquire_now-1.jpg",
      bgImage: "/images/inquiry-imgs/Sarvam-Inquire_now-2.jpg",
    },

    888: {
      name: "Stark Torre",
      image: "/images/inquiry-imgs/Torre-Inquire_now-1.jpg",
      bgImage: "/images/inquiry-imgs/Torre-Inquire_now-2.jpg",
    },
  };
  const projectData =
    inquiryProjectImages[projectId] || inquiryProjectImages[880];
  return (
    <section className="inquire-now-new-section">
      <div className="inquire-now-grid relative">
      <motion.div className="form-reveal-overlay" style={{ clipPath }} />
        {/* LEFT IMAGE */}
        <div className="vectorimage-form">
          <img src="/images/nb-palm/vector2.png" alt="" />
        </div>
        <div className="inquire-now-image">
          <img src={projectData.image} alt={projectData.name} />
        </div>

        {/* RIGHT FORM */}

        <div
          className="inquire-now-form-side"
          style={{
            backgroundImage: `url(${projectData.bgImage})`,
          }}
        >
          <div className="inquire-overlay-pattern"></div>

          <div
            ref={formRef}
            className="inquire-form-wrapper inner-flex inner-flex-medium"
          >
            
            <div className="section-title">
              <h2 className="white-color">Get In Touch</h2>
            </div>

            <div className=" project_detail_inquiry_form">
              <form
                id="inquiry_form_detail"
                name="inquiry_form_detail"
                className="inner-flex"
                onSubmit={handleSubmit}
              >
                <div className="form_wrapper">
                  <div className="contact_lable">
                    <span className="material-symbols-outlined icon-form-control">
                      person
                    </span>
                    <input
                      id="client_name"
                      name="client_name"
                      type="text"
                      className={`form-control form-control-iconpad ${
                        inquiryObj.client_name ? "ng-not-empty" : "ng-empty"
                      } ${errors.client_name ? "ng-invalid " : "ng-valid"} ${
                        inquiryObj.client_name ? "ng-touched" : ""
                      } ${
                        formSubmitted &&
                        (!inquiryObj.client_name || errors.client_name)
                          ? "error"
                          : ""
                      } `}
                      value={inquiryObj.client_name}
                      onChange={handleChange}
                      tabIndex={1}
                    />
                    <label className="md-lable" htmlFor="client_name">
                      Name
                    </label>
                    <div className="valid-icon-of-form">
                      <img
                        loading="lazy"
                        src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="contact_lable  relative">
                    <span className="material-symbols-outlined icon-form-control">
                      dialpad
                    </span>
                    <input
                      tabIndex={2}
                      id="client_contact_no_display"
                      name="client_contact_no_display"
                      type="text"
                      className={`form-control contact-form form-control-iconpad ${
                        inquiryObj.client_contact_no_display
                          ? "ng-not-empty"
                          : "ng-empty"
                      } ${
                        formSubmitted &&
                        (!inquiryObj.client_contact_no_display ||
                          errors.client_contact_no_display)
                          ? "error"
                          : ""
                      }
                                                                    ${
                                                                      !errors.client_contact_no_display &&
                                                                      inquiryObj
                                                                        .client_contact_no_display
                                                                        .length ===
                                                                        10
                                                                        ? "ng-valid"
                                                                        : "ng-invalid"
                                                                    } ${
                                                                      inquiryObj.client_contact_no_display
                                                                        ? "ng-touched"
                                                                        : ""
                                                                    }`}
                      value={inquiryObj.client_contact_no_display}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      minLength="10"
                      maxLength="10"
                    />
                    <label
                      className="md-lable contact_code"
                      htmlFor="contact_no"
                    >
                      Mobile Number
                    </label>
                    <div className="valid-icon-of-form">
                      <img
                        loading="lazy"
                        src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                        alt=""
                      />
                    </div>
                    <div className="conatct_number_input">
                      <div
                        className="country_code_data"
                        onClick={(event) => {
                          setCountryFlag(true);
                          event.stopPropagation();
                        }}
                        ng-click="country_code_click(); $event.stopPropagation();"
                      >
                        <div className="contact_country_flag">
                          <img
                            loading="lazy"
                            src={inquiryObj.flag}
                            alt="reecosys"
                          />
                        </div>
                        <div>&nbsp;+{inquiryObj.country}</div>
                        <div>
                          <i
                            className="fa fa-angle-down"
                            aria-hidden="true"
                          ></i>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`country_code_list_data ${
                        countryFlag ? "active" : ""
                      } `}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="search_c-code">
                        <input
                          type="text"
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                          placeholder="Search"
                        />
                      </div>
                      <ul>
                        {countryList != undefined &&
                          countryList.length > 0 &&
                          countryList
                            .filter(
                              (item) =>
                                item.phonecode.toString().includes(search) ||
                                item.nicename
                                  .toLowerCase()
                                  .includes(search.toLowerCase()),
                            )
                            .map((item, index) => (
                              <li
                                key={`${item.phonecode}-${item.nicename}-${index}`}
                              >
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleCountrySelect(
                                      item.phonecode,
                                      item.flag,
                                    );
                                  }}
                                >
                                  <div>
                                    <img src={item.flag} alt="country" />
                                  </div>
                                  <span className="display_country_code">
                                    +{item.phonecode}
                                  </span>{" "}
                                  {item.nicename}
                                </div>
                              </li>
                            ))}
                      </ul>
                    </div>
                  </div>
                  <div className="contact_lable">
                    <span className="material-symbols-outlined icon-form-control">
                      alternate_email
                    </span>
                    <input
                      id="email_address"
                      name="email_address"
                      type="email"
                      className={`form-control form-control-iconpad ${
                        inquiryObj.email_address ? "ng-not-empty" : "ng-empty"
                      }
                                                                     ${
                                                                       formSubmitted &&
                                                                       (!inquiryObj.email_address ||
                                                                         errors.email_address)
                                                                         ? "error"
                                                                         : ""
                                                                     }
                                                                     ${
                                                                       errors.email_address
                                                                         ? "ng-invalid"
                                                                         : "ng-valid"
                                                                     } ${
                                                                       inquiryObj.email_address
                                                                         ? "ng-touched"
                                                                         : ""
                                                                     }`}
                      value={inquiryObj.email_address}
                      onChange={handleChange}
                      tabIndex={3}
                    />

                    <label className="md-lable" htmlFor="email_address">
                      Email
                    </label>
                    <div className="valid-icon-of-form">
                      <img
                        loading="lazy"
                        src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                        alt=""
                      />
                    </div>
                  </div>

                  <div className="contact_lable commentbox">
                    <span className="material-symbols-outlined icon-form-control">
                      chat_bubble
                    </span>
                    <textarea
                      id="remarks"
                      name="remarks"
                      type="text"
                      // className={`form-control form-control-iconpad ${
                      //   inquiryObj.remarks
                      //     ? "ng-not-empty"
                      //     : "ng-empty"
                      // } ${inquiryObj.remarks ? "ng-touched" : ""}`}
                      className={`form-control form-control-iconpad ${
                        inquiryObj.remarks
                          ? "ng-not-empty ng-touched"
                          : "ng-empty"
                      }`}
                      value={inquiryObj.remarks}
                      onChange={handleChange}
                      rows="4"
                      tabIndex={4}
                    ></textarea>

                    <label className="md-lable" htmlFor="remark">
                      Comments
                    </label>
                  </div>
                  {/* <p style={{ width: "100%" }}>
                    By submitting this form, you agree to the{" "}
                    <a href="#" className="hover-color-link">
                      Terms & Conditions
                    </a>{" "}
                    of NB Buildcon.
                  </p> */}
                  <div className="sunmit-project-btn">
                    <button
                      className="reecosys-template-button button-style-white-filled"
                      type="submit"
                      tabIndex={5}
                    >
                      {/* <span className="material-symbols-outlined">send</span> */}
                      {submitLoad ? <p>Please Wait...</p> : <p>Submit</p>}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
